import React from "react";
import LegalPageLayout from "./LegalPageLayout";

export default function TermsSubscriptionPage() {
  return (
    <LegalPageLayout
      title="Términos de uso y condiciones de suscripción"
      subtitle="Reglas del servicio, planes, cobro, renovación y cancelación."
      updatedAt="18 de febrero de 2026"
    >
      <section className="panel">
        <h2 className="panel-title">Descripción del servicio</h2>
        <p>
          La plataforma permite organizar finanzas personales mediante importación de extractos, categorización de movimientos,
          análisis y planificación de ahorro.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Registro y uso de la cuenta</h2>
        <p>
          El usuario es responsable de custodiar sus credenciales y del uso de su cuenta. Debe facilitar información veraz y usar
          el servicio conforme a la ley, sin afectar seguridad ni disponibilidad.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Información precontractual esencial</h2>
        <p>
          Antes de contratar el plan Pro se muestran de forma clara: precio total con impuestos aplicables, periodicidad de cobro,
          funcionalidades incluidas, límites del plan Free, condiciones de renovación/cancelación y medios de pago aceptados por
          la pasarela externa.
        </p>
        <p>
          Idioma de contratación: español. El proceso de compra se realiza en línea y la confirmación se envía por el proveedor de
          pago y/o por correo electrónico.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Planes, prueba gratuita y límites</h2>
        <p>
          El servicio ofrece plan Free (gratuito con límites) y plan Pro (suscripción mensual o anual). El alta gratuita incluye
          30 días de prueba con funcionalidades ampliadas. Al finalizar, la cuenta continúa en plan Free salvo contratación de Pro.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Pago, renovación y cancelación</h2>
        <p>
          Las suscripciones se cobran mediante proveedor externo de pagos (p. ej., Stripe) y se renuevan automáticamente salvo
          cancelación previa. Al cancelar, el plan Pro se mantiene hasta el fin del periodo ya abonado.
        </p>
        <p>
          La cancelación debe realizarse antes de la siguiente fecha de renovación para evitar el cargo del siguiente periodo.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Facturación y justificantes</h2>
        <p>
          El detalle de cobros y facturas se consulta en el área de facturación del proveedor de pagos. La persona usuaria debe
          mantener actualizados sus datos de facturación cuando resulte necesario.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Derecho de desistimiento</h2>
        <p>
          En contrataciones a distancia de servicios digitales, el derecho de desistimiento puede quedar exceptuado cuando la ejecución
          del servicio comienza durante el periodo de desistimiento con consentimiento expreso y reconocimiento de dicha circunstancia
          por parte de la persona consumidora, conforme a la normativa de consumo aplicable.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Exclusión de asesoramiento y responsabilidad</h2>
        <p>
          La plataforma no presta asesoramiento financiero, fiscal ni de inversión. El titular no garantiza disponibilidad ininterrumpida
          y no responde por decisiones económicas tomadas por el usuario.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Atención a incidencias y reclamaciones</h2>
        <p>
          Para incidencias de servicio, cobros o cancelaciones puedes contactar en soporte@ahorrayrespira.com, indicando el email de
          cuenta y el detalle de la incidencia para su gestión.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Ley aplicable y fuero</h2>
        <p>
          Estas condiciones se rigen por la normativa española. En caso de conflicto con personas consumidoras, serán competentes
          los juzgados y tribunales del domicilio de la persona consumidora en los términos legalmente previstos.
        </p>
      </section>
    </LegalPageLayout>
  );
}
